import React from 'react';
import { Link } from 'react-router-dom';
import useMain from '../../hooks/useMain';
import Image from './../common/image';

const Crowdfunding = () => {
	const { theme } = useMain();
	return (
		<div className='container mb-5'>
			<div className='row align-items-center'>
				<div className='col-md-6 gy-4'>
					<h5 className={`text-uppercase text-set5-${theme}`}>
						Reward-Based Crowdfunding for the Development of Blockchain Projects
					</h5>
					<h1 className={`fw-bold text-set3-${theme}`}>
						Crowd Funding Model in MMP WORLD
					</h1>
					<p>
						The MMP WORLD platform utilizes a <b>reward-based crowdfunding</b> model to
						finance blockchain initiatives. In this model, individuals participate by
						investing in various funding packages and, in return, receive predefined
						financial rewards—such as monthly profit payouts, collaboration bonuses, and
						exclusive investment benefits.
					</p>
					<p>
						Unlike traditional models that rely heavily on large-scale investors, MMP
						WORLD aggregates micro-investments from thousands of contributors, creating
						a broad and inclusive funding base for innovative blockchain-based projects.
						The capital raised through this process is professionally managed by the BEM
						Foundation and is directed toward the development, execution, and growth of
						practical and profitable blockchain ventures.
					</p>
					<p>
						Participant rewards are distributed periodically based on the selected
						investment package, the duration of the investment, and project performance.
						This model not only enables income opportunities for individuals at any
						financial level but also empowers them to actively contribute to the growth
						and realization of promising crypto projects.
					</p>

					<Link
						to={'/crowdfunding'}
						className={`btn btn-set5-${theme} me-3`}>
						Read More
					</Link>
				</div>
				<div className='col-md-6'>
					<Image
						className={'w-100'}
						fileName={'home/crowdfunding.png'}
					/>
				</div>
			</div>
		</div>
	);
};

export default Crowdfunding;
